"use strict";
// English text definitions
Object.defineProperty(exports, "__esModule", { value: true });
exports.help = [
    "Interface Controls",
    "Function",
    "Button",
    "Key",
    "Gesture",
    "Description",
    "Slide Overview",
    "O",
    "Toggle the Overview of all slides.",
    "Toolbar",
    "T",
    "Toggle the visibility of the toolbar.",
    "All Slides",
    "A",
    "Toggle display of all slides on one page.",
    "First Slide",
    "Home",
    "Shake",
    "Navigate to first slide.",
    "Previous Slide",
    "\u2190, Page Up",
    "Swipe right, Tap/click left margin, Tilt left, Tip left",
    "Navigate to previous slide.",
    "Next Slide",
    "\u2192, Page Down, Space",
    "Swipe left, Tap/click right margin, Tilt right, Tip right",
    "Advance to next slide.",
    "Last Slide",
    "End",
    "Navigate to last slide.",
    "Print Settings",
    "P",
    "Toggle the Print Settings Panel.\n   Print settings are preserved in browser local storage.",
    "Settings",
    "S",
    "Toggle the Settings Panel.\n   Settings are preserved in browser local storage.",
    "Help",
    "H",
    "Toggle the Help Panel.",
    "Table of Contents",
    "C",
    "Toggle the Table of Contents (slide titles).",
    "Decrease Font Size",
    "-",
    "Decrease slide font size.\n   With Shift, decrease interface font size.",
    "Reset Font Size",
    "R",
    "Reset slide font size.\n   With Shift, reset interface font size.",
    "Increase Font Size",
    "+",
    "Increase slide font size.\n   With Shift, increase interface font size.",
    "Jump to Slide",
    "[J] 0-99 Return",
    "Jump to a specific slide.",
    "Close all Panels",
    "Escape",
    "Close all open panels.",
];
exports.settings = [
    "Tilt",
    "Shake",
    "Space To Advance",
    "Margin Tap Nav",
    "Low Light Mode",
    "Slide Fonts",
    "UI Fonts",
    "Make Slide Fonts Smaller (-)",
    "Reset Slide Fonts (R)",
    "Make Slide Fonts Larger (+)",
    "Make UI Fonts Smaller (Shift -)",
    "Reset UI Fonts (Shift R)",
    "Make UI Fonts Larger (Shift +)"
];
exports.print_settings = [
    "Show Link Destinations",
    "Show Slide Numbers",
    "Show Frame",
    "Print"
];
exports.toolbar = [
    "Show Toolbar (T)",
    "Slide Overview (O)",
    "Hide Toolbar (T)",
    "First Slide (Home)",
    "Previous Slide (\u2190)",
    "Next Slide (\u2192)",
    "Last Slide (End)",
    "Table of Contents (C)",
    "Settings (S)",
    "Print (P)",
    "Help (H)",
    "Display All Slides (A)",
    "Display Single Slides (A)"
];
exports.imageviewer = [
    "Reset Zoom (R)",
    "Zoom In (+)",
    "Zoom Out (-)",
    "Close (Esc)"
];
